/**
 * Sample values
 * window.base_domain = '.aperza.jp';
 window.tokenKey = 'atkn';
 window.base_cluez_member_domain = 'member.cluez.biz';
 window.cdn_base_domain = '//static.aperza.jp';
 window.env_locale_balloon = null;
 */
export default class AppConfig {
    /**
     * include lang code
     */
    get searchWebUrlPrefix() {
        return `${this.searchWebHost}${this.langCode === 'en' ? `/${this.langCode}` : ''}`;
    }
    /**
     * include lang code
     */
    get marketplaceWebUrlPrefix() {
        return `${this.marketplaceWebHost}${this.langCode === 'en' ? `/${this.langCode}` : ''}`;
    }
    get serviceType() {
        return this._serviceType;
    }
    set serviceType(value) {
        this._serviceType = value;
    }
    get env() {
        return this._env;
    }
    set env(value) {
        this._env = value;
    }
    get isAperzaCatalog() {
        return this._isAperzaCatalog;
    }
    set isAperzaCatalog(value) {
        this._isAperzaCatalog = value;
    }
    get isAperzaCatalogTop() {
        return this._isAperzaCatalogTop;
    }
    set isAperzaCatalogTop(value) {
        this._isAperzaCatalogTop = value;
    }
    get isAperzaMarketplace() {
        return this._isAperzaMarketplace;
    }
    set isAperzaMarketplace(value) {
        this._isAperzaMarketplace = value;
    }
    get isAperzaTv() {
        return this._isAperzaTv;
    }
    set isAperzaTv(value) {
        this._isAperzaTv = value;
    }
    get isAperzaSearchItemResultPage() {
        return this._isAperzaSearchItemResultPage;
    }
    set isAperzaSearchItemResultPage(value) {
        this._isAperzaSearchItemResultPage = value;
    }
    get isAperzaSearchCatalogResultPage() {
        return this._isAperzaSearchCatalogResultPage;
    }
    set isAperzaSearchCatalogResultPage(value) {
        this._isAperzaSearchCatalogResultPage = value;
    }
    get isAperzaNewsDomain() {
        return this._isAperzaNewsDomain;
    }
    set isAperzaNewsDomain(value) {
        this._isAperzaNewsDomain = value;
    }
    get isAperzaIdDomain() {
        return this._isAperzaIdDomain;
    }
    set isAperzaIdDomain(value) {
        this._isAperzaIdDomain = value;
    }
    get isAperzaAccountDomain() {
        return this._isAperzaAccountDomain;
    }
    set isAperzaAccountDomain(value) {
        this._isAperzaAccountDomain = value;
    }
    get isAperzaOrderDomain() {
        return this._isAperzaOrderDomain;
    }
    set isAperzaOrderDomain(value) {
        this._isAperzaOrderDomain = value;
    }
    get isOrderCheckout() {
        return this._isOrderCheckout;
    }
    set isOrderCheckout(value) {
        this._isOrderCheckout = value;
    }
    get isAperzaBusinessDomain() {
        return this._isAperzaBusinessDomain;
    }
    set isAperzaBusinessDomain(value) {
        this._isAperzaBusinessDomain = value;
    }
    get baseDomain() {
        return this._baseDomain;
    }
    set baseDomain(value) {
        this._baseDomain = value;
    }
    get baseComDomain() {
        return this._baseComDomain;
    }
    set baseComDomain(value) {
        this._baseComDomain = value;
    }
    get tokenKey() {
        return this._tokenKey;
    }
    set tokenKey(value) {
        this._tokenKey = value;
    }
    get langKey() {
        return this._langKey;
    }
    set langKey(value) {
        this._langKey = value;
    }
    get langCode() {
        return this._langCode;
    }
    set langCode(value) {
        this._langCode = value;
    }
    get baseCluezMemberDomain() {
        return this._baseCluezMemberDomain;
    }
    set baseCluezMemberDomain(value) {
        this._baseCluezMemberDomain = value;
    }
    get cdnHost() {
        return this._cdnHost;
    }
    set cdnHost(value) {
        this._cdnHost = value;
    }
    get envLocaleBalloon() {
        return this._envLocaleBalloon;
    }
    set envLocaleBalloon(value) {
        this._envLocaleBalloon = value;
    }
    get searchWebHost() {
        return this._searchWebHost;
    }
    set searchWebHost(value) {
        this._searchWebHost = value;
    }
    get aperzaTvHost() {
        return this._aperzaTvHost;
    }
    set aperzaTvHost(value) {
        this._aperzaTvHost = value;
    }
    get accountWebHost() {
        return this._accountWebHost;
    }
    set accountWebHost(value) {
        this._accountWebHost = value;
    }
    get marketplaceWebHost() {
        return this._marketplaceWebHost;
    }
    set marketplaceWebHost(value) {
        this._marketplaceWebHost = value;
    }
    get mainPage() {
        return this._mainPage;
    }
    set mainPage(value) {
        this._mainPage = value;
    }
    get automationNewsUrl() {
        return this._automationNewsUrl;
    }
    get aperzaIdHost() {
        return this._aperzaIdHost;
    }
    set aperzaIdHost(value) {
        this._aperzaIdHost = value;
    }
    get aperzaAccountHost() {
        return this._aperzaAccountHost;
    }
    set aperzaAccountHost(value) {
        this._aperzaAccountHost = value;
    }
    set automationNewsUrl(value) {
        this._automationNewsUrl = value;
    }
}
AppConfig.APERZA_SEARCH = 'search-aperza';
AppConfig.APERZA_EC = 'aperza-ec';
AppConfig.APERZA_CATALOG = 'catalog';
AppConfig.APERZA_NEWS = 'news-aperza';
AppConfig.APERZA_ID = 'id-aperza';
AppConfig.APERZA_ACCOUNT = 'account-aperza';
AppConfig.APERZA_ORDER = 'aperza-order';
AppConfig.APERZA_BIZ = 'aperza-biz';
AppConfig.APERZA_NECA = 'aperza-neca';
AppConfig.APERZA_TV = 'tv';
AppConfig.APERZA_DX = 'dx';
AppConfig.ENV_PROD = '';
AppConfig.ENV_STG = 'stg';
AppConfig.ENV_TEST = 'test';
AppConfig.ENV_TEST_2 = 'test2';
AppConfig.ENV_LOCAL = 'local';
AppConfig.API_HOST_PROD = 'https://api.aperza.com';
AppConfig.API_HOST_STG = 'https://api.stg.aperza.com';
AppConfig.API_HOST_TEST = 'https://api.test.aperza.com';
AppConfig.API_HOST_TEST_2 = 'https://api.test2.aperza.com';
AppConfig.API_HOST_LOCAL = 'http://localhost:8081';
export { AppConfig };
